export default __webpack_public_path__ + "static/media/logo.2f8a1e63.png";